module.exports = __webpack_public_path__ + "media/images/icon_minus-6daa5141d2979d0dae5c68997b520806.svg";